import { LineDictionaryModel, LineModel } from '@/lib/models/lines/types';
import { RouteLineApiV4Interface, RouteLinesApiV4Interface } from '@/types/api-types';

export const transformLineDictionary = (lines: RouteLinesApiV4Interface): LineDictionaryModel => {
  return Object.entries(lines).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: transformLine(value),
    };
  }, {} as LineDictionaryModel);
};

export const transformLine = (line: RouteLineApiV4Interface): LineModel => {
  return line;
};
